export const historyArchivalEnableCommand = `tctl --ns {namespace} namespace update -has enabled`;

export const historyArchivalLinks = null;

export const visibilityArchivalEnableCommand = `tctl --ns {namespace} namespace update -vas enabled`;



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/components/archival-disabled-messaging/constants.js